<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <k-p-i-value-boxes></k-p-i-value-boxes>
        </v-flex>

<!--        <v-flex xs12 v-show="!loading">-->
<!--            <v-card flat>-->
<!--                <v-card-title class="primary white&#45;&#45;text headline">-->
<!--                    Optimisation Savings-->
<!--                </v-card-title>-->
<!--                <v-layout row wrap>-->
<!--                    <v-flex xs12 lg9 v-if="data">-->
<!--                        <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12 lg3>-->
<!--                        <v-layout row wrap>-->
<!--                            <v-flex xs12>-->
<!--                                <value-box :value="totalSavingSum" unit="kWh" title="Saving after optimisation" icon="fa-piggy-bank"></value-box>-->
<!--                            </v-flex>-->
<!--                            <v-flex xs12>-->
<!--                                <value-box :value="totalPowerSum" unit="kWh" title="Actual usage after optimisation" icon="fa-bolt"></value-box>-->
<!--                            </v-flex>-->
<!--                            <v-flex xs12>-->
<!--                                <value-box :value="savingPercentage" unit="%" title="Saving" icon="fa-smile" class="green-icon"></value-box>-->
<!--                            </v-flex>-->

<!--                        </v-layout>-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
<!--            </v-card>-->
<!--        </v-flex>-->
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy Consumption Trend
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data2">
                        <vue-plotly :data="data2" :layout="layout2" :options="options2"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <cooling-load-stacked-area-plot agg="H"></cooling-load-stacked-area-plot>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <cooling-load-forecast-new></cooling-load-forecast-new>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <v-card>
                <v-card-title class="accent white--text title">
                    Latest Cooling Load Forecast Accuracy
                    <v-spacer></v-spacer>
                    <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
                        <v-icon>fa-info</v-icon>
                    </v-btn>
                    <cooling-load-explanation ref="explanationDialog"></cooling-load-explanation>
                </v-card-title>
                <v-card-text v-if="!loading">
                    <v-layout>
                        <v-flex xs12>
                            Forecast accuracy:
                            <vue-plotly v-if="data3" :data="data3" :layout="layout3" :options="options3"/>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Algorithmic Fault Detection
                </v-card-title>
                <v-layout row wrap>

                    <v-flex xs12>
                        <v-card>
                            <v-card-text>
                                <date-range-selector v-model="range"></date-range-selector>
                                <equipment-selector typeFilter="chiller*" v-model="equipment"></equipment-selector>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <anomaly :range="range" :equipment="equipment"></anomaly>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>



    </v-layout>
</template>

<script>
    import KPIValueBoxes from '../../components/kpi/KPIValueBoxes'
    import CoolingLoadStackedAreaPlot from '../../components/CoolingLoadStackedAreaPlot'
    import CoolingLoadForecastNew from '../../components/loadforecast/CoolingLoadForecastNew'
    import {callAPI,getResult,findLineByLeastSquares} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import ValueBox from '@/components/ValueBox'
    import CoolingLoadExplanation from '@/components/CoolingLoadExplanation'
    import moment from 'moment'
    import Anomaly from "../../components/Anomaly";
    import DateRangeSelector from "../../components/DateRangeSelector";
    import EquipmentSelector from "../../components/EquipmentSelector";



    export default {
        name: 'EsDashboardOld',
        components: { KPIValueBoxes,CoolingLoadStackedAreaPlot,CoolingLoadForecastNew,VuePlotly,ValueBox,CoolingLoadExplanation,Anomaly,DateRangeSelector,EquipmentSelector},
        computed: {
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            }
        },
        data () {
            return {
                range: {start: moment().subtract(31, "days").format('YYYY-MM-DD'), end: moment().subtract(1, "days").format('YYYY-MM-DD')},
                forcedBlue:[],
                loading:false,
                equipment: 'Chiller2',
                data:null,
                totalPowerSum:0,
                totalSavingSum:0,
                data2:null,
                data3:null,
                // data4:null,
                options: {},
                options2: {},
                options3: {},
                // options4: {},
                layout:{

                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range:[18,35]
                    },
                    yaxis: {
                        title: 'Total energy consumption (kWh)',
                        rangemode:'tozero',
                        range:[0,25000],
                    }
                },
                layout2:{
                    yaxis: {
                        title: 'Energy consumption (kWh)'
                    },
                    xaxis: {
                        title: 'Date (daily)'
                    }
                },
                layout3:{
                    title: 'Cooling Load Accuracy',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Date (every 15 minutes)',
                    },
                    yaxis: {
                        title: 'Cooling Load (kW)'
                    },
                },
                // layout4:{
                //     title: 'Cooling Load Accuracy Trend',
                //     hovermode: 'closest',
                //     xaxis: {
                //         title: 'Time',
                //     },
                //     yaxis: {
                //         title: 'Difference'
                //     },
                // }

            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            }
        },
        mounted() {
            let rangeStart = "2020-01-01"//_.get(this.$route.query,'rangeStart', moment().subtract(100, "days").format('YYYY-MM-DD'))
            let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
            let me=this;
            me.loading=true;
            let promises=[];
            let timestamp=null;
            let totalPower=null;
            let avgTemp=null;
            let chillerTypes=[
                "Chiller3",
                "Chiller4",
                "Chiller5",
                "Chiller2",
                "Chiller1"
            ]
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(chillerTypes.indexOf(equip.equipment_type)>-1){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['Power']
                        }
                    ))
                }
                // else if(equip.equipment_type==='Primary_Chilled_Water_Pump'){
                //     promises.push(callAPI('data/',
                //         {
                //             'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                //             'equipment_name': equip.equipment_name,
                //             'agg': 'D',
                //             'agg_op': 'sum',
                //             'date_range':[rangeStart, rangeEnd+" 23:59"],
                //             'sensor_names': ['Power']
                //         }
                //     ))
                // }
            }

            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': 'Weather',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': ['Outdoor_Temperature']
                }
            ))


            Promise.all(promises).then(function(reses) {
                for (let res of reses) {
                    if (!timestamp) {
                        timestamp = res.data.timestamp;
                    }
                }
                let secondChartData = [];

                for (let res of reses) {
                    if (res.data['Power']) {
                        secondChartData.push({
                            x: timestamp,
                            y: res.data['Power'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                            name: JSON.parse(res.config.data)["equipment_name"],
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    }
                }
                secondChartData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                me.data2=secondChartData;
                me.loading=false;
            });

            getResult({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                result_name: 'cooling load'
            }).then(function(result){
                if(result['result'][0]){
                    let actualdata = result['result'][0]['content']['df']
                    let newdata = result['result'][0]['content']['forecast']
                    me.data3=[
                        {
                            marker: {
                                color: 'rgb(0,0,0)',
                                shape: 'spline',
                                width: 1,
                                opacity: 0.9
                            },
                            x: actualdata.timestamp,
                            y: actualdata.total_CL,
                            name: 'Actual observed value',
                            type: 'scatter',
                            mode: 'lines'
                        },
                        {
                            line: {
                                color: 'rgb(0,76,255)',
                                shape: 'spline',
                                width: 1,
                                opacity: 0.9
                            },
                            x: newdata.timestamp,
                            y: newdata.yhat,
                            name: 'Predicted value',
                            type: 'scatter',
                            mode: 'lines'
                        },
                    ]
                }

                // let differential=[];
                // for(let tsindex in newdata.timestamp){
                //     let main=actualdata.total_CL[tsindex] ? actualdata.total_CL[tsindex] : 0
                //     if(main){
                //         differential.push(Math.abs((main-newdata.yhat[tsindex])/main * 100))
                //     } else {
                //         differential.push(0)
                //     }
                //
                // }
                // me.data4=[
                //     {
                //         x: newdata.timestamp,
                //         y: differential,
                //         name: 'Differential',
                //         type: 'scatter',
                //         mode: 'lines'
                //     },
                // ]
            });

        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
</style>
